import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {
  Button,
  Typography,
} from '@material-ui/core';
import { ArrowBack } from '@material-ui/icons';

const styles = theme => ({
  leftIcon: {
    marginRight: theme.spacing.unit,
  },
  button: {
    margin: '5px',
  },
});

const BackButton = ({ classes, history }) => (
  <Button className={classes.button} onClick={() => history.goBack()}>
    <ArrowBack className={classes.leftIcon} />
    <Typography> Volver </Typography>
  </Button>
);

BackButton.propTypes = {
  classes: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

export default withStyles(styles)(BackButton);



// WEBPACK FOOTER //
// ./src/components/BackButton.js